export class PeriodsSelectors {
  static endpoint = 'endpoint';
  static periods = 'periods';
  static systemParameters = 'systemParameters';
}
